import { SingleBillId } from 'utils/api/models/bills/singleBillId';
import { convertToArray } from 'utils/converters/convertToArray';
import modelsResolver from 'utils/api/models/utils/modelsResolver';

export type BillingIds = {
	_billingIds: any;
	billingIds: SingleBillId[];
};
export interface IBillingAccount {
	name: string;
	id: string;
	accountId: string;
	billingName: string;
	key: string;
	billsHistoryFetched: boolean;
	accountType?: string
}

const model: types.models.InputModel = {
	_billingIds: 'response.getCorpBillingIdsResponse.billingIds',
	billingIds: function(model: BillingIds) {
		return convertToArray(model._billingIds).map((billingId) => modelsResolver(billingId, 'singleBillId'));
	},
};

export default model;
